import { userEventCreate } from "../../../config/Services";

export const eventTracker = ({ metaData, eventType }) => {
  if (!isMobileDevice()) {
    const userDetails = localStorage.getItem("retailUserDetails");
    const uidx = userDetails ? JSON.parse(userDetails).uidx : "";
    const roles = userDetails ? JSON.parse(userDetails).roles : [];
    const userName = userDetails
      ? JSON.parse(userDetails).firstName + " " + JSON.parse(userDetails)?.secondName
      : "NA";
    const orgId = localStorage.getItem("orgId");
    const locId = localStorage.getItem("locId");
    const daySessionId = localStorage.getItem("daySessionId");
    const licenseId = localStorage.getItem("licenseId");
    const sessionId = localStorage.getItem("sessionId");

    let role;
    if (roles.includes("CASHIER")) {
      role = "CASHIER";
    } else if (roles.includes("POS_USER")) {
      role = "POS_USER";
    } else if (roles.includes("POS_MANAGER")) {
      role = "POS_MANAGER";
    }
    let payload = {
      uidx: uidx,
      createdByName: userName,
      role: role,
      organizationId: orgId,
      locationId: locId,
      sourceService: "CART",
      eventType: eventType,
      dayId: daySessionId,
      licenseId: licenseId,
      sessionId: sessionId,
      meta: metaData,
    };

    userEventCreate(payload)
      .then((res) => {})
      .catch((error) => {
        console.log({ error });
      });
  }
};

const isMobileDevice = () => {
  return window.innerWidth < 600;
};
